/**
 * Form Validation Script
 * Подсветка незаполненных полей в формах регистрации, входа и других
 */
(function() {
    'use strict';

    /**
     * Инициализация валидации форм
     */
    function initFormValidation() {
        // Находим все формы на странице
        const forms = document.querySelectorAll('form');

        forms.forEach(function(form) {
            // Находим все обязательные поля в форме
            const requiredFields = form.querySelectorAll('input[required], textarea[required], select[required]');

            // Добавляем обработчик события submit
            form.addEventListener('submit', function(e) {
                let isValid = true;
                let firstInvalidField = null;

                // Проверяем каждое обязательное поле
                requiredFields.forEach(function(field) {
                    // Убираем предыдущие классы ошибок
                    field.classList.remove('error', 'is-invalid');

                    // Проверяем валидность поля
                    if (!field.checkValidity()) {
                        isValid = false;
                        field.classList.add('error', 'is-invalid');

                        // Сохраняем первое невалидное поле для фокуса
                        if (!firstInvalidField) {
                            firstInvalidField = field;
                        }
                    }
                });

                // Если форма невалидна, предотвращаем отправку и фокусируемся на первом невалидном поле
                if (!isValid) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (firstInvalidField) {
                        firstInvalidField.focus();
                        firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                    
                    if (window.SaborlistaNotifications) {
                        const validationErrorMsg = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.validationError) || 'Please fill in all required fields correctly.';
                        window.SaborlistaNotifications.error(validationErrorMsg);
                    }

                    return false;
                }
            });

            // Добавляем обработчики для удаления класса ошибки при вводе
            requiredFields.forEach(function(field) {
                // Убираем класс ошибки при изменении значения
                field.addEventListener('input', function() {
                    if (field.checkValidity()) {
                        field.classList.remove('error', 'is-invalid');
                    }
                });

                // Убираем класс ошибки при потере фокуса, если поле валидно
                field.addEventListener('blur', function() {
                    if (field.checkValidity()) {
                        field.classList.remove('error', 'is-invalid');
                    } else {
                        field.classList.add('error', 'is-invalid');
                    }
                });

                // Обработчик события invalid для HTML5 валидации
                field.addEventListener('invalid', function(e) {
                    e.preventDefault();
                    field.classList.add('error', 'is-invalid');
                });
            });
        });
    }

    // Инициализация при загрузке DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFormValidation);
    } else {
        initFormValidation();
    }
})();

